import { useParams } from 'react-router-dom'
import ElementList from '../ElementList/ElementList'
import useSurveyAnswer, { PrefilledType, Status } from '../../../hooks/useSurveyAnswer/useSurveyAnswer'
import Success from '../ElementList/Success/Success'
import SmallContainer from '../../../UI/Container/SmallContainer'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import TimeLimitReached from '../TimeLimitReached/TimeLimitReached'

const Live = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { surveyUUID } = useParams()
  const { survey, surveyAnswer, updateElement, updateOrganizationUnitUUID, updateDayNumber, submit, prefilledType, status, timeLimitReached } =
    useSurveyAnswer(surveyUUID)

  if (!surveyAnswer) return <></>
  if (timeLimitReached) return <TimeLimitReached survey={survey} />
  return (
    <div>
      {status === Status.PENDING && (
        <ElementList
          survey={survey}
          answer={surveyAnswer}
          updateElement={updateElement}
          updateOrganizationUnitUUID={updateOrganizationUnitUUID}
          updateDayNumber={updateDayNumber}
          submit={submit}
        />
      )}
      {prefilledType !== PrefilledType.NONE && status === Status.PENDING && (
        <div className="w-full">
          <SmallContainer>
            {prefilledType === PrefilledType.TEAM && <div className="text-darkRed text-center text-sm">{t.survey.answer.prefilledHintTeam}</div>}
            {prefilledType === PrefilledType.MANAGER && (
              <div className="text-darkRed text-center text-sm">{t.survey.answer.prefilledHintManager}</div>
            )}
            {prefilledType === PrefilledType.LEADER && <div className="text-darkRed text-center text-sm">{t.survey.answer.prefilledHintLeader}</div>}
          </SmallContainer>
        </div>
      )}
      {status === Status.SUCCESS && <Success survey={survey} />}
    </div>
  )
}

export default Live
